/**
 * Shared constants used across the application
 */

export const API_URL = process.env.REACT_APP_API_URL;
export const DEFAULT_IMAGE = "https://mdidlwnnrgzwjwgydotv.supabase.co/storage/v1/object/public/event/default/pexels-runffwpu-10313674.jpg";
